import { RootState } from "../../../../store";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";

export const resourceExplorerDataGridFilteredByLiveUsageResourcesSelector = (
  state: RootState,
) => {
  return resourceExplorerStateSelector(state).filteredByLiveUsages;
};
